import { Container, ContainerDescription } from './styles'
import { FiInfo } from "react-icons/fi";
import React from 'react';
const AlertInfo = ({ title, text }) => {
    return (
        <Container>
            <FiInfo size={24} style={{ color: "var(--neutral-900)", flexShrink: 0 }} />
            <ContainerDescription>
                <h1>{title}</h1>
                <p>{text}</p>
            </ContainerDescription>
        </Container>
    );
}

export default AlertInfo;